import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import BulkUploadActionsMenu from './BulkUploadActionsMenu';
import CustomPagination from '../../../components/customPagination';
import dayjs from 'dayjs';

const BulkUploadTable = ({ handlePaginationChange }) => {
  const { bulkUploads, totalDocuments } = useSelector((state) => state.bulkUploads);

  const columns = [
    {
      field: 'filename',
      headerName: 'File Name',
      flex: 1.5,
    },
    {
      field: 'source',
      headerName: 'Source',
      flex: 0.5,
      valueFormatter: (params) => {
        return params === 'bulk_upload' ? 'WEB' : params?.toUpperCase();
      },
    },
    {
      field: 'document_type',
      headerName: 'Document Type',
      flex: 0.8,
      valueFormatter: (params) => {
        return params
          ?.split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },
    {
      field: 'created_on',
      headerName: 'Upload Date',
      flex: 1,
      valueFormatter: (params) => {
        const timestamp = params;
        if (!timestamp) return '';
        return dayjs(timestamp).format('YYYY-MM-DD hh:mm:ss A');
      },
    },
    {
      field: 'total_documents_count',
      headerName: 'Total',
      flex: 0.4,
    },
    {
      field: 'processed_documents_count',
      headerName: 'Imported Successfully',
      flex: 0.5,
    },
    {
      field: 'error_documents_count',
      headerName: 'Import Failed',
      flex: 0.4,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.8,
      id: 'bulk-upload-status',
      valueFormatter: (params) => {
        if (params === 'template_mismatched') {
          return 'Upload Failed';
        }
        return params
          ?.split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },
    {
      field: 'template_name',
      headerName: 'Template Name',
      flex: 1,
      valueFormatter: (params) => {
        return params
          ?.split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      },
    },
    {
      field: 'uploaded_by',
      headerName: 'Uploaded By',
      flex: 1,
    },
    {
      field: 'row',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => <BulkUploadActionsMenu row={row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={[...bulkUploads].sort((a, b) => {
          const dateA = new Date(a.created_on).toLocaleString();
          const dateB = new Date(b.created_on).toLocaleString();
          return new Date(dateB).getTime() - new Date(dateA).getTime();
        })}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page + 1, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default BulkUploadTable;
